var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-2"},[_c('b',{staticClass:"pr-2"},[_vm._v(_vm._s(_vm.link.numeroTOL))]),_c('a',{attrs:{"target":"_blank","href":_vm.url_for_rails_documento_show(_vm.link.id)}},[_vm._v(_vm._s(_vm.link.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }